<template>
	<div id="pre_menu_left" class="pre_menu_left">
		<ul v-loading="fullscreenLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<li v-for="(item, index) in menu" :key="index">
				<span v-bind:id="'btn_menu_one' + item.id" class="btn_menu_one" @click="isShowMenu(item)">
					{{ item.label }}
				</span>
				<ul v-bind:id="'menu_one' + item.id" class="btn_menu_two">
					<li v-bind:id="'menu_two' + d.id" v-for="(d, index) in item.children" :key="index"
						@click="gochildren(d.id,d.value)">
						<span>
							{{ d.label }}
						</span>
					</li>
				</ul>
			</li>
		</ul>



		<!-- <el-tree :data="menu" :props="defaultProps" @node-click="handleNodeClick">
    </el-tree> -->
	</div>
</template>

<script>
	/*
名称：初级版本的左边菜单栏
日期：2019-06-10
作者：hj
目标：
1、配置查询参数,生成二级菜单
*/
	import api from '@/utils/type.js'
	import {
		GoUrl,
		Message
	} from '@/utils/method.js';
	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';
	import {
		GetShort,
		SetShort,
		DelShort
	} from "@/utils/localstore.js";

	export default {
		name: 'pre_menu_left',
		data() {
			return {
				msg_obj: {},
				fullscreenLoading: false,
				menu: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				userno: '',
				menu_click: []
			};
		},
		props: {
			pre_left_data: {
				type: Array,
				default: []
			}
		},
		created: function() {
			this.userno = GetShort('userno');
			this.loaddata();
			GoUrl(this, 'home');
		},
		watch: {
			pre_left_data(val) {
				// console.log('传值='+this.menu.length);
				// console.log(val);
				if (val.length >= 0) {
					this.menu_click = val;
				}
			}
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize


			// window.addEventListener('scroll', function() {
			// 	// console.log('滚动');
			// 	that.left_height();
			// }, false);


		},
		methods: {
			left_height: function() {
				this.$nextTick(function() {
					let temp_height = $(window).height(); //当前浏览器窗口的 宽高
					// console.log('height=' + temp_height);
					let header_height = document.getElementById('header').offsetHeight; //头部高度
					console.log('头部高度=' + header_height)
					let th = 0;
					// th = temp_height - 60 - 10;
					th = temp_height - Number(header_height) - 32 - 42;
					let css = '';
					css = 'height: ' + th + 'px;min-height: ' + th + 'px;max-height: ' + th + 'px;';
					document.getElementById('pre_menu_left').style.cssText = css;
				});
			},
			loaddata: function() {
				let t = (localStorage.getItem('userdata'));
				if (t == null || t === undefined || t == '') {
					alert('登录信息已经过期,请重新登录!');
					location.href = '/login';
					return;
				} else {
					t = JSON.parse(t);
					// console.log(t);
					this.userno = t[0].uno;
					this.rid = t[0].rid;
				}

				this.fullscreenLoading = true;
				this.$post(
					api.http_method, Method_EasySelect('datagetmenu', this.userno)
				).then(res => {
					// console.log(res)
					res = JSON.parse(res)
					// console.log(res.data);
					if (Number(res.data.status) == 1) {
						// console.log(res.data.data);
						this.menu = res.data.data;
					}
					this.fullscreenLoading = false;
				});
			},
			handleNodeClick(data) {
				// console.log(data.value);
				// console.log(this.userno+' == '+this.rid);
				if (data.value != '') {
					GoUrl(this, data.value);
				}
			},
			isShowMenu: function(item) {
				// console.log(item);
				// console.log('子菜单长度=' + item.children.length + ' id=' + item.id);
				if (item.children.length == 0) {

					if (item.value == 'login') {
						this.$confirm('是否删除登录信息, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							localStorage.setItem('pwd', '');
							localStorage.setItem('userno', '');
							localStorage.setItem('userdata', '');
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							GoUrl(this, item.value);
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
							GoUrl(this, item.value);
						});
					} else {
						// console.log(item.value);
						GoUrl(this, item.value);
						// 点击首页，则清空所有已经选择的菜单
						this.$emit("my-menu-left", []);
					}
				} else {
					var isShow = document.getElementById('menu_one' + item.id).style.display;

					// if (item.value == 'home') {
					//   this.menu_click = [];
					//   this.$emit("my-menu-left", this.menu_click);
					// }

					if (!isShow || String(isShow) == 'none') {
						$('#menu_one' + item.id).slideDown("slow");
					} else {
						$('#menu_one' + item.id).slideUp("slow");
					}
				}
			},
			gochildren: function(tid, path) {
				// console.log('菜单id=' + tid + ' 路径=' + path);
				// 颜色保留
				var name = '';
				var menu_no = '';
				for (var i = 0; i < this.menu.length; i++) {
					// console.log(this.data_tab[i]);
					for (var j = 0; j < this.menu[i].children.length; j++) {
						if (this.menu[i].children[j].id == tid) {
							// console.log(this.menu[i].children[j]);
							document.getElementById('menu_two' + tid).style.background = '#a3d5ff';
							name = this.menu[i].children[j].label;
							menu_no = this.menu[i].children[j].no;
						} else {
							document.getElementById('menu_two' + this.menu[i].children[j].id).style.background =
								'white';
						}
					}
				}

				// console.log('菜单id=' + tid + ' 路径=' + path+ ' name=' + name+ ' menu_no=' + menu_no);


				let r = (Math.random() * 10000 + '').substring(0, 4);
				let parm = {
					"check_key": menu_no,
					"random": r
				};
				GoUrl(this, path, parm);
				// 传参 用来刷新 顶部 导航
				this.refreshData(tid, name, path, parm)
			},
			refreshPush: function(path, parm) {
				// console.log('推送菜单刷新这里', path, parm);

				var isExist = false;
				var id = 0,
					name = '';
				// console.log(this.menu);
				for (var i = 0; i < this.menu.length; i++) {
					for (var j = 0; j < this.menu[i].children.length; j++) {
						if (this.menu[i].children[j].value == path) {
							isExist = true;
							this.menu[i].flag = '1';
							id = this.menu[i].children[j].id;
							name = this.menu[i].children[j].label;
							break;
						}
					}
				}
				// 删除原来的
				var t = [];
				for (var i = 0; i < this.menu_click.length; i++) {
					if (this.menu_click[i].path != path) {
						t.push(this.menu_click[i]);
					}
				}
				this.menu_click = [];
				this.menu_click = t;

				if (isExist) {
					var o = {};
					o.id = id;
					o.name = name;
					o.path = path;
					o.parm = parm;
					o.flag = '1';
					this.menu_click.push(o);
				}

				//这里不需要参数，只需要名称正确即可


				this.$emit("my-menu-left", this.menu_click);

			},
			refreshData: function(id, name, path, parm) {
				// console.log('id='+id+' name='+name+' path='+path);
				var isExist = false;
				for (var i = 0; i < this.menu_click.length; i++) {
					if (this.menu_click[i].id == id) {
						isExist = true;
						this.menu_click[i].flag = '1';
					} else {
						this.menu_click[i].flag = '0';
					}
				}
				// 现在最多显示12个菜单
				if (this.menu_click.length >= 8) {
					this.menu_click.shift();
				}

				if (!isExist) {
					var o = {};
					o.id = id;
					o.name = name;
					o.path = path;
					o.parm = parm;
					o.flag = '1';
					this.menu_click.push(o);
				}

				this.$emit("my-menu-left", this.menu_click);
			}

		}
	};
</script>

<style scoped>
	.pre_menu_left {
		overflow-x: hidden;
		overflow-y: auto;
		/* width: calc(100% - 15px); */
		width: 100%;

		border-right: 1px solid #3a8ee6;


	}

	/* img{box-shadow:阴影类型 X轴位移 Y轴位移 阴影大小 阴影扩展 阴影颜色 } */

	.pre_menu_left>ul {
		list-style-type: none;
		margin: 0;
		padding: 0;

		/* -moz-box-shadow: 6px 0px 10px #006fde;
		-webkit-box-shadow: 6px 0px 10px #006fde;
		box-shadow: 6px 0px 10px #006fde; */

		-moz-shadow-right: 0px 0px 0px 20px #006fde;
		-webkit-shadow-right: 0px 0px 0px 20px #006fde;
		shadow-right: 0px 0px 0px 20px #006fde;
	}

	.pre_menu_left>ul>li:hover {
		cursor: pointer;
		background: #787878;
	}

	.pre_menu_left>ul>li>span:hover {
		cursor: pointer;
		background: #0582ca;
	}

	.btn_menu_one {
		display: block;
		background-color: #5aa9e6;
		font-size: 16px;
		color: white;
		margin-top: 5px;
		/* 360浏览器 极速模式不识别  */
		/* padding: 5px, 25px, 5px, 25px; */
		padding-top: 5px;
		padding-right: 5px;
		padding-bottom: 5px;
		padding-left: 5px;
		width: 100%;
		height: 30px;
		line-height: 30px;
		/* border-radius: 10px 10px 10px 10px; */
		/* font-weight: bold; */
	}

	.btn_menu_two {
		height: auto;
		display: none;
		list-style-type: none;
		padding: 0px;
	}

	.btn_menu_two>li {
		font-size: 16px;
		padding-right: 5px;
		padding-left: 15px;
		padding-top: 5px;
		padding-bottom: 5px;
		width: 100%;
		height: 24px;
		line-height: 24px;
		background: white;
	}

	.btn_menu_two>li:hover {
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;

	}
</style>
